"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetLoginInfo = exports.useResetPassword = exports.useCheckPassword = exports.useAuthenticate = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var loading_1 = require("remota-client/hook/loading");
var login_1 = require("app/module/login");
var useAuthenticate = function () {
    var state = (0, react_redux_1.useSelector)(function (state) { return state; });
    var resultToAction = (0, react_1.useCallback)(function (res) {
        return (0, login_1.setToken)(res);
    }, []);
    var _a = __read((0, loading_1.useHttpPostBody)(state.loading, "/auth", resultToAction, undefined), 2), run = _a[0], status = _a[1];
    return [state.login.token, run, status];
};
exports.useAuthenticate = useAuthenticate;
var useCheckPassword = function (token) {
    var loadingState = (0, react_redux_1.useSelector)(function (state) { return state.loading; });
    var _a = __read((0, react_1.useState)(), 2), state = _a[0], setState = _a[1];
    var resultToAction = (0, react_1.useCallback)(function (res) {
        setState(res);
    }, [setState]);
    var _b = __read((0, loading_1.useHttpPostBody)(loadingState, "/auth/check/".concat(token), resultToAction, undefined), 2), run = _b[0], status = _b[1];
    return [run, state, status];
};
exports.useCheckPassword = useCheckPassword;
var useResetPassword = function (resetToken) {
    var state = (0, react_redux_1.useSelector)(function (state) { return state; });
    var resultToAction = (0, react_1.useCallback)(function (res) {
        return (0, login_1.setToken)(res);
    }, []);
    var _a = __read((0, loading_1.useHttpPostBody)(state.loading, "/auth/reset/".concat(resetToken), resultToAction, undefined), 2), run = _a[0], status = _a[1];
    return [run, state.login.token, status];
};
exports.useResetPassword = useResetPassword;
var useGetLoginInfo = function (resetToken) {
    var state = (0, react_redux_1.useSelector)(function (state) { return state; });
    var resultToAction = (0, react_1.useCallback)(function (res) {
        return (0, login_1.getLoginInfo)(res);
    }, []);
    var status = (0, loading_1.useHttpPost)(state.loading, "/auth/loginInfo/".concat(resetToken), null, state.login.tenantCode === undefined, resultToAction, undefined);
    var loginInfo = state.login.tenantCode && state.login.userCode
        ? { tenantCode: state.login.tenantCode, userCode: state.login.userCode }
        : undefined;
    return [loginInfo, status];
};
exports.useGetLoginInfo = useGetLoginInfo;
